import React, { Fragment, PureComponent } from 'react';
import { func, string } from 'prop-types';
import { TextField, Box } from '@mui/material';
import { Button } from '../../Button';
import IntlMessages from '../../../util/IntlMessages';
import { AUTH_ERROR_TYPES } from '../../../constants/Values';

/**
 * Represents stateless functional component TemporaryPasswordForm
 * Asks user with "staff" role to enter temporary password
 * @param {object} props Component props
 * @param {function} props.onFieldChange Password change callback function
 * @param {function} props.showAuthLoader Shows form loader if form is submitted
 * @param {function} props.submitTemporaryPassword Dispatches an action of a specific type
 * @param {String} props.temporaryPassword Represents temporary password entered by a user
 * @return {Component}
 * */
class TemporaryPasswordForm extends PureComponent {
  static propTypes = {
    errorMessage: string,
    onFieldChange: func,
    resetErrorMessage: func,
    showAuthLoader: func,
    submitTemporaryPassword: func,
    temporaryPassword: string,
  };

  static defaultProps = {
    errorMessage: '',
    onFieldChange: () => {},
    resetErrorMessage: () => {},
    showAuthLoader: () => {},
    submitTemporaryPassword: () => {},
    temporaryPassword: '',
  };

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.resetErrorMessage(AUTH_ERROR_TYPES.TEMPORARY_PASS);
    }
  }

  onFormSubmit = event => {
    event.preventDefault();

    if (!this.props.temporaryPassword) {
      return;
    }

    this.submitTemporaryPassword();
  };

  handleFieldChange = event => this.props.onFieldChange(event.target.id, event.target.value);

  submitTemporaryPassword = () => {
    this.props.showAuthLoader();
    this.props.submitTemporaryPassword();
  };

  render() {
    return (
      <Fragment>
        <Box className="app-login-header" sx={{ mb: 3 }}>
          <h2>
            <IntlMessages id="auth.tempPass.header" />
          </h2>
        </Box>
        <div className="app-login-form">
          <form onSubmit={this.onFormSubmit}>
            <fieldset>
              <TextField
                autoFocus
                sx={{ mt: { xs: 1, sm: 3 }, mb: { xs: 1, sm: 3 } }}
                defaultValue={this.props.temporaryPassword}
                error={!!this.props.errorMessage}
                fullWidth
                helperText={
                  <IntlMessages
                    id={this.props.errorMessage || 'auth.verificationCode.helperText'}
                  />
                }
                id="temporaryPassword"
                label={<IntlMessages id="auth.tempPass.label" />}
                margin="normal"
                onChange={this.handleFieldChange}
              />
              <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Button
                  size="large"
                  labelId="auth.verificationCode.buttonText"
                  color="primary"
                  disabled={!this.props.temporaryPassword}
                  type="submit"
                  variant="contained"
                />
              </Box>
            </fieldset>
          </form>
        </div>
      </Fragment>
    );
  }
}

export default TemporaryPasswordForm;
